import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.SignpostContentPromo = class SignpostContentPromo extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-content-promo-signpost';
	}

	constructor(element) {
		super(element);
	}

	render() {
		this.setVars();
		this.setEventListeners();
	}

	setVars() {
		this.$anchorableElement = this.$element.find('.fa-content-promo__block-link');
		this.elementHasFocusClass = 'fa-content-promo--has-focus';
	}

	setEventListeners() {
		this.$anchorableElement.on('mouseover focus', this.onElementFocusState.bind(this));
		this.$anchorableElement.on('mouseout focusout', this.onElementBlur.bind(this));
	}

	onElementFocusState() {
		this.$element.addClass(this.elementHasFocusClass);
	}

	onElementBlur(event) {
		const toElement = event.toElement || event.relatedTarget;
		const toElementIsRelated = $.contains(this.$element[0], toElement);

		if (!toElementIsRelated) {
			this.$element.removeClass(this.elementHasFocusClass);
		}
	}
};

$(function() {
    new Snappy.Component.SignpostContentPromo();

    //Image Gallery
    $('.prev, .next').css('cursor','pointer');
    
    //Hide all images except the first one
    $(".slide-content").each(function(){
        $(this).find('.slide-content__items picture:gt(0)').hide();
    });

    $('.prev').click(function() {
        $(this).parent().find('.slide-content__items picture:first-child').hide();
        $(this).parent().find('.slide-content__items picture:last-child')
                        .prependTo($(this).parent().find('.slide-content__items')).hide();
        $(this).parent().find('.slide-content__items picture:first-child').show();
    });
		
    $('.next').click(function() {
        $(this).parent()
               .find('.slide-content__items picture:first-child').hide().next().show()
                    .end().appendTo($(this)
                        .parent().find('.slide-content__items'));
    });	

})



// WEBPACK FOOTER //
// ./components/signpostContentPromo/scripts/signpostContentPromo.js